import React, { useEffect, useState } from "react";

import { HubTableTemplate } from "../../components";
import { useDeletePartById } from "../../hooks";
import { WarningDeleteDialog } from "../../dialogs";

import CustomerPartsContextMenu from "./CustomerPartsContextMenu";

const items = [
  { id: "partName", label: "Part Name" },
  { id: "partNumber", label: "Part Number" },
  { id: "weight", label: "Weight" },
  { id: "lastSentPrice", label: "Last Quoted Price", sortable: true },
];

const keys = [
  {
    variant: "blueBold",
    value: "partName",
    navigate: true,
    route: "parts",
    id: "id",
  },
  {
    variant: "blueBold",
    value: "partNumber",
    navigate: true,
    route: "parts",
    id: "id",
  },
  { value: "weight", defaultValue: "—" },
  { value: "lastSentPrice", isCurrency: true, defaultValue: 0 },
];

export const CustomerPartsTable = ({ data = [] }) => {
  const [deletingId, setDeletingId] = useState(false);
  const { mutate: deletePartById, isSuccess } = useDeletePartById();

  const handleClose = () => setDeletingId(false);
  const handleSubmit = () => deletingId && deletePartById(deletingId);

  useEffect(() => {
    isSuccess && handleClose();
  }, [isSuccess]);

  const ContextMenu = ({ item }) => (
    <CustomerPartsContextMenu id={item?.id} setDeletingId={setDeletingId} />
  );

  return (
    <>
      <HubTableTemplate
        id="CustomerPartsTable"
        headerProps={{ items, includeEnd: true }}
        bodyProps={{
          items: data,
          keys,
          ContextMenu,
        }}
      />
      <WarningDeleteDialog
        isOpen={!!deletingId}
        onClose={handleClose}
        onSubmit={handleSubmit}
        title="You are about to delete this part!"
      />
    </>
  );
};

export default CustomerPartsTable;
